import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { PinGate } from "@/components/PinGate";
import HomePage from "@/pages/HomePage";
import StartPage from "@/pages/StartPage";
import SurveyPage from "@/pages/SurveyPage";
import SummaryPage from "@/pages/SummaryPage";
import ThankYouPage from "@/pages/ThankYouPage";
import ResultPage from "@/pages/ResultPage";
import WeightsPage from "@/pages/WeightsPage";
import BlankFormPage from "@/pages/BlankFormPage";
import PlanPage from "@/pages/PlanPage";
import StaffStartPage from "@/pages/StaffStartPage";
import StaffSurveyPage from "@/pages/StaffSurveyPage";
import StaffThankYouPage from "@/pages/StaffThankYouPage";
import LivePage from "@/pages/LivePage";
import MethodPage from "@/pages/MethodPage";
import PhotoImportPage from "@/pages/PhotoImportPage";
import EventsPage from "@/pages/EventsPage";
import EventSheetPage from "@/pages/EventSheetPage";
import BusinessPage from "@/pages/BusinessPage";
import QuotePage from "@/pages/QuotePage";
import SettingsPage from "@/pages/SettingsPage";
import ComparePage from "@/pages/ComparePage";
import BenchmarkPage from "@/pages/BenchmarkPage";
import TerritoryPage from "@/pages/TerritoryPage";

function App() {
  return (
    <div className="page-bg grain">
      <BrowserRouter>
        <PinGate>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/nuovo" element={<StartPage />} />
          <Route path="/compila/:id" element={<SurveyPage />} />
          <Route path="/riepilogo/:id" element={<SummaryPage />} />
          <Route path="/grazie/:id" element={<ThankYouPage />} />
          <Route path="/risultato/:id" element={<ResultPage />} />
          <Route path="/pesi" element={<WeightsPage />} />
          <Route path="/modulo" element={<BlankFormPage />} />
          <Route path="/piano/:id" element={<PlanPage />} />
          <Route path="/rapido/:id" element={<LivePage />} />
          <Route path="/metodo" element={<MethodPage />} />
          <Route path="/metodo/:id" element={<MethodPage />} />
          <Route path="/foto" element={<PhotoImportPage />} />
          <Route path="/eventi" element={<EventsPage />} />
          <Route path="/eventi/:id" element={<EventSheetPage />} />
          <Route path="/attivita" element={<BusinessPage />} />
          <Route path="/impostazioni" element={<SettingsPage />} />
          <Route path="/confronto" element={<ComparePage />} />
          <Route path="/benchmark" element={<BenchmarkPage />} />
          <Route path="/benchmark/:id" element={<BenchmarkPage />} />
          <Route path="/territorio" element={<TerritoryPage />} />
          <Route path="/eventi/:id/preventivo" element={<QuotePage />} />
          <Route path="/staff/:id/nuovo" element={<StaffStartPage />} />
          <Route path="/staff/:id/:staffId" element={<StaffSurveyPage />} />
          <Route path="/staff/:id/:staffId/grazie" element={<StaffThankYouPage />} />
        </Routes>
        </PinGate>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
